import * as React from 'react';
import Grid from '@material-ui/core/Grid';

import { utcToLocal } from '../../datetime';
import { CreditRequestAuditAction, ICreditRequestAuditResponse } from '../../models/credit-request';
import AuditEventLog, { IAuditEvent } from '../Order/AuditEventLog';

export interface ICreditRequestAuditInfoProps {
  auditEntries: ICreditRequestAuditResponse[];
}

const auditActions: { [action: string]: string } = {
  [CreditRequestAuditAction.Created]: 'Created',
  [CreditRequestAuditAction.Saved]: 'Modified',
  [CreditRequestAuditAction.Submitted]: 'Submitted',
  [CreditRequestAuditAction.Resubmitted]: 'Resubmitted',
  [CreditRequestAuditAction.Returned]: 'Returned',
  [CreditRequestAuditAction.SentToAccountsReceivable]: 'Sent to Accounts Receivable',
  [CreditRequestAuditAction.Rejected]: 'Rejected',
  [CreditRequestAuditAction.Closed]: 'Closed',
  [CreditRequestAuditAction.Completed]: 'Completed',
};

const describeCreditRequestEvent = (event: IAuditEvent): string => {
  const comment = event.payload && event.payload.comment;
  return `${event.action} by ${event.repCode}${comment ? ` ${comment}` : ''}`;
};

const CreditRequestAuditInfo: React.SFC<ICreditRequestAuditInfoProps> = ({
  auditEntries,
}) => {
  const events: IAuditEvent[] = auditEntries.map((entry) => ({
    action: auditActions[entry.action] || '',
    date: utcToLocal(entry.eventDateTimeUtc).toISO(),
    repCode: entry.actorRepCode,
    payload: entry.payload as IAuditEvent['payload'],
  }));

  return (
    <Grid container className="section audit-info">
      <Grid item xs={1} />
      <Grid item xs={10}>
        <h2>Audit Information</h2>
        <AuditEventLog
          events={events}
          describeEvent={describeCreditRequestEvent}
        />
      </Grid>
    </Grid>
  );
};

export default CreditRequestAuditInfo;
